const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 12,
  cy: 12.03,
  r: 5
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 12.03c0-.16-.05-.31-.11-.44h.01c-.04-.08-.85-1.69-2.74-3.31-1.9-1.64-4.9-3.26-9.16-3.25-4.26-.01-7.27 1.61-9.15 3.24C.96 9.89.15 11.5.11 11.58h.01c-.07.14-.12.28-.12.45 0 .16.05.31.11.44H.1c.04.08.85 1.69 2.74 3.31s4.89 3.25 9.15 3.24c4.26.01 7.27-1.62 9.15-3.24 1.89-1.62 2.7-3.23 2.74-3.31h-.01c.08-.14.13-.28.13-.44zm-4.23 2.3c-1.62 1.35-4.09 2.69-7.77 2.69-3.74-.01-6.23-1.38-7.85-2.76-.8-.69-1.38-1.38-1.75-1.89-.09-.13-.17-.25-.24-.35.34-.52 1-1.42 2.06-2.31C5.84 8.37 8.31 7.03 12 7.03c3.74.01 6.23 1.38 7.85 2.76.8.69 1.38 1.38 1.75 1.89.09.13.17.25.24.35-.34.51-1.01 1.41-2.07 2.3z"
});

const SvgVisible = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVisible, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/visible.c3d1e4da.svg";
export { ForwardRef as ReactComponent };